import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Welcome back!');
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Login failed');
    }
    setLoading(false);
  };

  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + '/auth/callback';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#050505] pt-24 flex items-center justify-center">
      <div className="w-full max-w-md mx-4">
        <div className="bg-[#121212] border border-white/5 rounded-sm p-8" data-testid="login-form">
          <h1 className="font-heading text-3xl text-center mb-8">LOGIN</h1>
          <form onSubmit={handleSubmit} className="space-y-4">
            <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-[#0F0F0F] border border-white/10 text-white placeholder:text-gray-600 focus:border-[#D62828] rounded-sm h-12 px-4" data-testid="login-email" required />
            <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-[#0F0F0F] border border-white/10 text-white placeholder:text-gray-600 focus:border-[#D62828] rounded-sm h-12 px-4" data-testid="login-password" required />
            <button type="submit" disabled={loading} className="w-full bg-[#D62828] hover:bg-[#B91C1C] text-white py-3 rounded-sm font-bold uppercase tracking-wider transition-all btn-glow disabled:opacity-50" data-testid="login-submit">
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
          <div className="my-6 flex items-center gap-4">
            <div className="flex-1 border-t border-white/10"></div>
            <span className="text-gray-500 text-sm">or</span>
            <div className="flex-1 border-t border-white/10"></div>
          </div>
          <button onClick={handleGoogleLogin} className="w-full border border-white/20 hover:border-white/40 text-white py-3 rounded-sm font-semibold transition-all flex items-center justify-center gap-2" data-testid="google-login">
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Continue with Google
          </button>
          <p className="text-center text-gray-400 mt-6 text-sm">
            Don't have an account?{' '}
            <Link to="/register" className="text-[#D62828] hover:underline">Register</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
